import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const JEWEL = "#e0466b";
const JEWEL_HI = "#ff86a6";

function gemUnit(cx: number, cy: number, cz: number, s: number, c: string, hi: string): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: c, position: [cx, cy, cz], scale: [1, 1.25, 1] as const },
    { geometry: new THREE.IcosahedronGeometry(s * 0.5, 0), color: hi, position: [cx, cy + s * 0.55, cz] },
  ];
}

export const jewelGem = defineModel({
  id: "jewel-gem",
  batchId: "characters",
  name: "Jewel gem",
  tags: ["good", "cargo", "precious"],
  fits: ["carry"],
  summary: "A pair of faceted jewels -- a carriable good for an avatar's carry socket.",
  description:
    "Two faceted jewels with highlights at held scale, ported from age-of-mcp's " +
    "goods (`jewel`). Mount it in a player's or worker's `carry` socket to show " +
    "the figure hauling jewels.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: (): Part[] => [
    ...gemUnit(0, 0.04, 0.01, 0.05, JEWEL, JEWEL_HI),
    ...gemUnit(0.04, 0.025, 0.02, 0.03, JEWEL, JEWEL_HI),
  ],
  animations: [],
});
